import React from 'react';
import { SimplePage } from '../components/shared/SharedComponents';
import {
  LegalPageContent,
  LegalLastUpdated,
  LegalSection,
  LegalSectionTitle,
  LegalParagraph,
  LegalSubsectionTitle,
  LegalInfoLine,
  renderLegalContent,
} from '../components/legal/legalPagePrimitives';
import { useContent } from '../hooks/useContent';

function PrivacyPolicy() {
  const { privacyPolicy } = useContent();

  const title = privacyPolicy?.title || 'Privacy Policy';
  const description = privacyPolicy?.description || '';
  const lastUpdated = privacyPolicy?.lastUpdated;
  const lastUpdatedLabel = privacyPolicy?.lastUpdatedLabel || 'Last Updated:';
  const dataController = privacyPolicy?.dataController;
  const dataControllerLabel = privacyPolicy?.dataControllerLabel || 'Data Controller:';
  const contactDPO = privacyPolicy?.contactDPO;
  const contactDPOLabel = privacyPolicy?.contactDPOLabel || 'Contact / Data Protection Officer (DPO):';
  const emptyContentMessage = privacyPolicy?.emptyContentMessage || 'Our full privacy policy will be published here soon. Until then, feel free to reach out with any questions.';
  const sections = Array.isArray(privacyPolicy?.sections) ? privacyPolicy.sections : [];

  return (
    <SimplePage title={title} description={description}>
      <LegalPageContent>
        {lastUpdated && <LegalLastUpdated>{lastUpdatedLabel} {lastUpdated}</LegalLastUpdated>}
        {dataController && <LegalInfoLine><strong>{dataControllerLabel}</strong> {dataController}</LegalInfoLine>}
        {contactDPO && <LegalInfoLine><strong>{contactDPOLabel}</strong> {contactDPO}</LegalInfoLine>}

        {sections.length > 0 ? (
          sections.map((section, sectionIndex) => (
            <LegalSection key={`${section?.title || 'section'}-${sectionIndex}`}>
              {section?.title && <LegalSectionTitle>{section.title}</LegalSectionTitle>}

              {Array.isArray(section?.paragraphs) && section.paragraphs.length > 0 ? (
                section.paragraphs.map((paragraph, paragraphIndex) => {
                  // Check if paragraph is an object with text and subsections
                  if (typeof paragraph === 'object' && paragraph !== null && paragraph.hasOwnProperty('text')) {
                    return (
                      <div key={`para-${paragraphIndex}`}>
                        {paragraph.text && <LegalParagraph>{paragraph.text}</LegalParagraph>}
                        {Array.isArray(paragraph.subsections) && paragraph.subsections.length > 0 && (
                          <div>
                            {paragraph.subsections.map((subsection, subsectionIndex) => {
                              const isEmptyTitle = !subsection?.title || subsection.title === '';
                              return (
                                <div key={`sub-${subsectionIndex}`} style={{ marginTop: isEmptyTitle ? '16px' : '28px' }}>
                                  {subsection?.title && <LegalSubsectionTitle>{subsection.title}</LegalSubsectionTitle>}
                                  {renderLegalContent(subsection?.paragraphs, isEmptyTitle)}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  }
                  // Regular string paragraph
                  if (typeof paragraph === 'string') {
                    return <LegalParagraph key={`para-${paragraphIndex}`}>{paragraph}</LegalParagraph>;
                  }
                  return null;
                })
              ) : (
                <LegalParagraph>
                  {emptyContentMessage}
                </LegalParagraph>
              )}

              {/* Legacy support: section-level subsections (for backward compatibility) */}
              {Array.isArray(section?.subsections) && section.subsections.length > 0 && (
                <div>
                  {section.subsections.map((subsection, subsectionIndex) => {
                    const isEmptyTitle = !subsection?.title || subsection.title === '';
                    return (
                      <div key={`legacy-sub-${subsectionIndex}`} style={{ marginTop: isEmptyTitle ? '16px' : '28px' }}>
                        {subsection?.title && <LegalSubsectionTitle>{subsection.title}</LegalSubsectionTitle>}
                        {renderLegalContent(subsection?.paragraphs, isEmptyTitle)}
                      </div>
                    );
                  })}
                </div>
              )}
            </LegalSection>
          ))
        ) : (
          <LegalParagraph>
            {emptyContentMessage}
          </LegalParagraph>
        )}
      </LegalPageContent>
    </SimplePage>
  );
}

export default PrivacyPolicy;

